import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { sessionStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import amplifyconfig from './amplifyconfiguration.json';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

Amplify.configure(amplifyconfig);

// Use sessionStorage instead of localStorage - logs out when browser closes
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
